export const translations = {
  en: {
    common: {
      dashboard: "Dashboard",
      profile: "Profile",
      logout: "Log out",
      hey: "Hey",
      language: "Language",
      learningLanguage: "Learning Language",
      selectLanguage: "Select a language",
      saveSuccess: "Updated successfully",
      upgradeRequired: "Upgrade Required",
      standardPremiumOnly: "This feature is available only on Standard and Premium plans.",
      viewPlans: "View Plans"
    },
    routes: {
      dashboard: "Dashboard",
      exploreSkills: "Explore Skills",
      myLearning: "My Learning",
      myCoach: "My Coach",
      challenges: "Challenges",
      personalCourses: "Personal Course",
      skillAssessment: "Skill Assessment",
      h2hQuiz: "H2H Quiz",
      profile: "Profile"
    },
    coach: {
      title: "Personalized daily + weekly learning plan",
      subtitle: "Built from your progress, quiz trends, activity streak, overload, and your current goal.",
      planInputs: "Plan Inputs",
      tuneInputs: "Tune these and regenerate your plan.",
      goal: "Goal",
      timeAvailable: "Time available today (minutes)",
      generate: "Generate My Plan",
      generating: "Generating",
      wrongTopics: "Wrong Topics to Fix",
      todayPlan: "Today's Plan",
      weeklyBlueprint: "Weekly Blueprint",
      recommendations: "Coach Recommendations"
    },
    challenges: {
      newActivity: "New Activity",
      title: "Challenge Mode",
      subtitle: "Real-life scenarios, clear rubric, AI evaluation, and rewards. This proves ability beyond quizzes.",
      create: "Create Challenge",
      skill: "Skill",
      duration: "Duration",
      difficulty: "Difficulty",
      generate: "Generate Challenge",
      yourSubmission: "Your Submission (text for now)",
      submit: "Submit For AI Evaluation",
      rewards: "Rewards",
      recentAttempts: "Recent Attempts",
      aiEvaluation: "AI Evaluation"
    }
  },
  es: {
    common: {
      dashboard: "Panel",
      profile: "Perfil",
      logout: "Cerrar sesión",
      hey: "Hola",
      language: "Idioma",
      learningLanguage: "Idioma de aprendizaje",
      selectLanguage: "Selecciona un idioma",
      saveSuccess: "Actualizado correctamente",
      upgradeRequired: "Actualización requerida",
      standardPremiumOnly: "Esta función está disponible solo en los planes Estándar y Premium.",
      viewPlans: "Ver planes"
    },
    routes: {
      dashboard: "Panel",
      exploreSkills: "Explorar habilidades",
      myLearning: "Mi aprendizaje",
      myCoach: "Mi coach",
      challenges: "Desafíos",
      personalCourses: "Crear curso personal",
      skillAssessment: "Evaluación",
      h2hQuiz: "Quiz H2H",
      profile: "Perfil"
    },
    coach: {
      title: "Plan de aprendizaje diario + semanal personalizado",
      subtitle: "Basado en tu progreso, resultados de quiz, racha, carga y objetivo actual.",
      planInputs: "Entradas del plan",
      tuneInputs: "Ajusta estos valores y regenera tu plan.",
      goal: "Objetivo",
      timeAvailable: "Tiempo disponible hoy (minutos)",
      generate: "Generar mi plan",
      generating: "Generando",
      wrongTopics: "Temas a reforzar",
      todayPlan: "Plan de hoy",
      weeklyBlueprint: "Plan semanal",
      recommendations: "Recomendaciones"
    },
    challenges: {
      newActivity: "Nueva actividad",
      title: "Modo desafío",
      subtitle: "Escenarios reales, rúbrica clara, evaluación con IA y recompensas.",
      create: "Crear desafío",
      skill: "Habilidad",
      duration: "Duración",
      difficulty: "Dificultad",
      generate: "Generar desafío",
      yourSubmission: "Tu entrega (texto por ahora)",
      submit: "Enviar para evaluación IA",
      rewards: "Recompensas",
      recentAttempts: "Intentos recientes",
      aiEvaluation: "Evaluación IA"
    }
  },
 fr: {
    common: {
      dashboard: "Tableau de bord",
      profile: "Profil",
      logout: "Se déconnecter",
      hey: "Salut",
      language: "Langue",
      learningLanguage: "Langue d’apprentissage",
      selectLanguage: "Sélectionner une langue",
      saveSuccess: "Mise à jour réussie",
      upgradeRequired: "Mise à niveau requise",
      standardPremiumOnly: "Cette fonctionnalité est disponible uniquement pour les plans Standard et Premium.",
      viewPlans: "Voir les plans"
    },
    routes: {
      dashboard: "Tableau de bord",
      exploreSkills: "Explorer les compétences",
      myLearning: "Mon apprentissage",
      myCoach: "Mon coach",
      challenges: "Défis",
      skillAssessment: "Évaluation des compétences",
      h2hQuiz: "Quiz H2H",
      profile: "Profil"
    },
    coach: {
      title: "Plan d’apprentissage quotidien et hebdomadaire personnalisé",
      subtitle: "Basé sur vos progrès, résultats de quiz, régularité, charge et objectif actuel.",
      planInputs: "Paramètres du plan",
      tuneInputs: "Ajustez ces paramètres et régénérez votre plan.",
      goal: "Objectif",
      timeAvailable: "Temps disponible aujourd’hui (minutes)",
      generate: "Générer mon plan",
      generating: "Génération",
      wrongTopics: "Sujets à corriger",
      todayPlan: "Plan du jour",
      weeklyBlueprint: "Plan hebdomadaire",
      recommendations: "Recommandations du coach"
    },
    challenges: {
      newActivity: "Nouvelle activité",
      title: "Mode défi",
      subtitle: "Scénarios réels, critères clairs, évaluation par IA et récompenses.",
      create: "Créer un défi",
      skill: "Compétence",
      duration: "Durée",
      difficulty: "Difficulté",
      generate: "Générer un défi",
      yourSubmission: "Votre soumission (texte pour l’instant)",
      submit: "Soumettre pour évaluation IA",
      rewards: "Récompenses",
      recentAttempts: "Tentatives récentes",
      aiEvaluation: "Évaluation IA"
    }
  },

  de: {
    common: {
      dashboard: "Dashboard",
      profile: "Profil",
      logout: "Abmelden",
      hey: "Hey",
      language: "Sprache",
      learningLanguage: "Lernsprache",
      selectLanguage: "Sprache auswählen",
      saveSuccess: "Erfolgreich aktualisiert",
      upgradeRequired: "Upgrade erforderlich",
      standardPremiumOnly: "Diese Funktion ist nur für Standard- und Premium-Pläne verfügbar.",
      viewPlans: "Pläne ansehen"
    },
    routes: {
      dashboard: "Dashboard",
      exploreSkills: "Fähigkeiten entdecken",
      myLearning: "Mein Lernen",
      myCoach: "Mein Coach",
      challenges: "Herausforderungen",
      skillAssessment: "Fähigkeitsbewertung",
      h2hQuiz: "H2H Quiz",
      profile: "Profil"
    },
    coach: {
      title: "Personalisierter täglicher + wöchentlicher Lernplan",
      subtitle: "Basierend auf Fortschritt, Quiz-Trends, Lernserie, Belastung und Ziel.",
      planInputs: "Plan-Einstellungen",
      tuneInputs: "Anpassen und Plan neu generieren.",
      goal: "Ziel",
      timeAvailable: "Heute verfügbare Zeit (Minuten)",
      generate: "Meinen Plan generieren",
      generating: "Wird generiert",
      wrongTopics: "Schwächen beheben",
      todayPlan: "Heutiger Plan",
      weeklyBlueprint: "Wochenplan",
      recommendations: "Coach-Empfehlungen"
    },
    challenges: {
      newActivity: "Neue Aktivität",
      title: "Challenge-Modus",
      subtitle: "Reale Szenarien, klare Bewertung, KI-Analyse und Belohnungen.",
      create: "Challenge erstellen",
      skill: "Fähigkeit",
      duration: "Dauer",
      difficulty: "Schwierigkeit",
      generate: "Challenge generieren",
      yourSubmission: "Deine Abgabe (vorerst Text)",
      submit: "Zur KI-Bewertung einreichen",
      rewards: "Belohnungen",
      recentAttempts: "Letzte Versuche",
      aiEvaluation: "KI-Bewertung"
    }
  },

  it: {
    common: {
      dashboard: "Dashboard",
      profile: "Profilo",
      logout: "Esci",
      hey: "Ciao",
      language: "Lingua",
      learningLanguage: "Lingua di apprendimento",
      selectLanguage: "Seleziona una lingua",
      saveSuccess: "Aggiornato con successo",
      upgradeRequired: "Aggiornamento richiesto",
      standardPremiumOnly: "Questa funzione è disponibile solo nei piani Standard e Premium.",
      viewPlans: "Visualizza piani"
    },
    routes: {
      dashboard: "Dashboard",
      exploreSkills: "Esplora competenze",
      myLearning: "Il mio apprendimento",
      myCoach: "Il mio coach",
      challenges: "Sfide",
      skillAssessment: "Valutazione competenze",
      h2hQuiz: "Quiz H2H",
      profile: "Profilo"
    },
    coach: {
      title: "Piano di apprendimento giornaliero e settimanale personalizzato",
      subtitle: "Basato su progressi, quiz, costanza, carico e obiettivo.",
      planInputs: "Impostazioni piano",
      tuneInputs: "Modifica e rigenera il piano.",
      goal: "Obiettivo",
      timeAvailable: "Tempo disponibile oggi (minuti)",
      generate: "Genera il mio piano",
      generating: "Generazione",
      wrongTopics: "Argomenti da migliorare",
      todayPlan: "Piano di oggi",
      weeklyBlueprint: "Piano settimanale",
      recommendations: "Raccomandazioni"
    },
    challenges: {
      newActivity: "Nuova attività",
      title: "Modalità sfida",
      subtitle: "Scenari reali, criteri chiari, valutazione IA e premi.",
      create: "Crea sfida",
      skill: "Competenza",
      duration: "Durata",
      difficulty: "Difficoltà",
      generate: "Genera sfida",
      yourSubmission: "La tua risposta (solo testo)",
      submit: "Invia per valutazione IA",
      rewards: "Ricompense",
      recentAttempts: "Tentativi recenti",
      aiEvaluation: "Valutazione IA"
    }
  },

  zh: {
    common: {
      dashboard: "仪表盘",
      profile: "个人资料",
      logout: "退出登录",
      hey: "你好",
      language: "语言",
      learningLanguage: "学习语言",
      selectLanguage: "选择语言",
      saveSuccess: "更新成功",
      upgradeRequired: "需要升级",
      standardPremiumOnly: "此功能仅限标准版和高级版使用。",
      viewPlans: "查看套餐"
    },
    routes: {
      dashboard: "仪表盘",
      exploreSkills: "探索技能",
      myLearning: "我的学习",
      myCoach: "我的教练",
      challenges: "挑战",
      skillAssessment: "技能评估",
      h2hQuiz: "H2H 测验",
      profile: "个人资料"
    },
    coach: {
      title: "个性化每日与每周学习计划",
      subtitle: "基于你的进度、测验趋势、连续学习和目标。",
      planInputs: "计划设置",
      tuneInputs: "调整后重新生成计划。",
      goal: "目标",
      timeAvailable: "今日可用时间（分钟）",
      generate: "生成我的计划",
      generating: "生成中",
      wrongTopics: "需加强的主题",
      todayPlan: "今日计划",
      weeklyBlueprint: "每周计划",
      recommendations: "教练建议"
    },
    challenges: {
      newActivity: "新活动",
      title: "挑战模式",
      subtitle: "真实场景、清晰标准、AI 评估与奖励。",
      create: "创建挑战",
      skill: "技能",
      duration: "时长",
      difficulty: "难度",
      generate: "生成挑战",
      yourSubmission: "你的提交（暂仅文本）",
      submit: "提交 AI 评估",
      rewards: "奖励",
      recentAttempts: "最近尝试",
      aiEvaluation: "AI 评估"
    }
  },

  ar: {
    common: {
      dashboard: "لوحة التحكم",
      profile: "الملف الشخصي",
      logout: "تسجيل الخروج",
      hey: "مرحبًا",
      language: "اللغة",
      learningLanguage: "لغة التعلم",
      selectLanguage: "اختر اللغة",
      saveSuccess: "تم التحديث بنجاح",
      upgradeRequired: "الترقية مطلوبة",
      standardPremiumOnly: "هذه الميزة متاحة فقط لخطط Standard و Premium.",
      viewPlans: "عرض الخطط"
    },
    routes: {
      dashboard: "لوحة التحكم",
      exploreSkills: "استكشاف المهارات",
      myLearning: "تعلمي",
      myCoach: "مدربي",
      challenges: "التحديات",
      skillAssessment: "تقييم المهارات",
      h2hQuiz: "اختبار H2H",
      profile: "الملف الشخصي"
    },
    coach: {
      title: "خطة تعلم يومية وأسبوعية مخصصة",
      subtitle: "مبنية على تقدمك ونتائج الاختبارات والاستمرارية والهدف.",
      planInputs: "إعدادات الخطة",
      tuneInputs: "قم بالتعديل وإعادة التوليد.",
      goal: "الهدف",
      timeAvailable: "الوقت المتاح اليوم (دقائق)",
      generate: "إنشاء خطتي",
      generating: "جاري الإنشاء",
      wrongTopics: "مواضيع تحتاج تحسين",
      todayPlan: "خطة اليوم",
      weeklyBlueprint: "الخطة الأسبوعية",
      recommendations: "توصيات المدرب"
    },
    challenges: {
      newActivity: "نشاط جديد",
      title: "وضع التحدي",
      subtitle: "سيناريوهات واقعية، تقييم واضح، تحليل ذكاء اصطناعي ومكافآت.",
      create: "إنشاء تحدي",
      skill: "المهارة",
      duration: "المدة",
      difficulty: "الصعوبة",
      generate: "إنشاء التحدي",
      yourSubmission: "مشاركتك (نص فقط حاليًا)",
      submit: "إرسال للتقييم بالذكاء الاصطناعي",
      rewards: "المكافآت",
      recentAttempts: "محاولات حديثة",
      aiEvaluation: "تقييم الذكاء الاصطناعي"
    }
  },

  ru: {
    common: {
      dashboard: "Панель",
      profile: "Профиль",
      logout: "Выйти",
      hey: "Привет",
      language: "Язык",
      learningLanguage: "Язык обучения",
      selectLanguage: "Выберите язык",
      saveSuccess: "Успешно обновлено",
      upgradeRequired: "Требуется обновление",
      standardPremiumOnly: "Функция доступна только в тарифах Standard и Premium.",
      viewPlans: "Посмотреть тарифы"
    },
    routes: {
      dashboard: "Панель",
      exploreSkills: "Навыки",
      myLearning: "Моё обучение",
      myCoach: "Мой коуч",
      challenges: "Испытания",
      skillAssessment: "Оценка навыков",
      h2hQuiz: "H2H Викторина",
      profile: "Профиль"
    },
    coach: {
      title: "Персональный дневной и недельный план обучения",
      subtitle: "Основан на прогрессе, тестах, серии занятий и цели.",
      planInputs: "Настройки плана",
      tuneInputs: "Настройте и пересоздайте план.",
      goal: "Цель",
      timeAvailable: "Доступное время сегодня (минуты)",
      generate: "Создать план",
      generating: "Создание",
      wrongTopics: "Темы для улучшения",
      todayPlan: "План на сегодня",
      weeklyBlueprint: "План на неделю",
      recommendations: "Рекомендации"
    },
    challenges: {
      newActivity: "Новое задание",
      title: "Режим испытаний",
      subtitle: "Реальные сценарии, ИИ-оценка и награды.",
      create: "Создать испытание",
      skill: "Навык",
      duration: "Длительность",
      difficulty: "Сложность",
      generate: "Создать испытание",
      yourSubmission: "Ваш ответ (текст)",
      submit: "Отправить на ИИ-оценку",
      rewards: "Награды",
      recentAttempts: "Недавние попытки",
      aiEvaluation: "ИИ-оценка"
    }
  },

  ja: {
    common: {
      dashboard: "ダッシュボード",
      profile: "プロフィール",
      logout: "ログアウト",
      hey: "こんにちは",
      language: "言語",
      learningLanguage: "学習言語",
      selectLanguage: "言語を選択",
      saveSuccess: "更新しました",
      upgradeRequired: "アップグレードが必要です",
      standardPremiumOnly: "この機能は Standard および Premium プラン限定です。",
      viewPlans: "プランを見る"
    },
    routes: {
      dashboard: "ダッシュボード",
      exploreSkills: "スキル探索",
      myLearning: "学習中",
      myCoach: "マイコーチ",
      challenges: "チャレンジ",
      skillAssessment: "スキル評価",
      h2hQuiz: "H2H クイズ",
      profile: "プロフィール"
    },
    coach: {
      title: "パーソナライズされた学習プラン",
      subtitle: "進捗、クイズ結果、継続状況、目標に基づきます。",
      planInputs: "プラン設定",
      tuneInputs: "調整して再生成します。",
      goal: "目標",
      timeAvailable: "今日の学習時間（分）",
      generate: "プランを生成",
      generating: "生成中",
      wrongTopics: "復習が必要な項目",
      todayPlan: "今日のプラン",
      weeklyBlueprint: "週間プラン",
      recommendations: "おすすめ"
    },
    challenges: {
      newActivity: "新しいアクティビティ",
      title: "チャレンジモード",
      subtitle: "実践的な課題、AI評価、報酬。",
      create: "チャレンジ作成",
      skill: "スキル",
      duration: "時間",
      difficulty: "難易度",
      generate: "生成",
      yourSubmission: "提出内容（テキスト）",
      submit: "AI評価に送信",
      rewards: "報酬",
      recentAttempts: "最近の挑戦",
      aiEvaluation: "AI評価"
    }
  },

  hi: {
    common: {
      dashboard: "डैशबोर्ड",
      profile: "प्रोफ़ाइल",
      logout: "लॉग आउट",
      hey: "नमस्ते",
      language: "भाषा",
      learningLanguage: "सीखने की भाषा",
      selectLanguage: "भाषा चुनें",
      saveSuccess: "सफलतापूर्वक अपडेट किया गया",
      upgradeRequired: "अपग्रेड आवश्यक",
      standardPremiumOnly: "यह सुविधा केवल Standard और Premium प्लान के लिए उपलब्ध है।",
      viewPlans: "प्लान देखें"
    },
    routes: {
      dashboard: "डैशबोर्ड",
      exploreSkills: "कौशल खोजें",
      myLearning: "मेरा सीखना",
      myCoach: "मेरा कोच",
      challenges: "चुनौतियाँ",
      skillAssessment: "कौशल मूल्यांकन",
      h2hQuiz: "H2H क्विज़",
      profile: "प्रोफ़ाइल"
    },
    coach: {
      title: "व्यक्तिगत दैनिक और साप्ताहिक अध्ययन योजना",
      subtitle: "आपकी प्रगति और लक्ष्य पर आधारित।",
      planInputs: "योजना सेटिंग्स",
      tuneInputs: "समायोजित करें और पुनः बनाएँ।",
      goal: "लक्ष्य",
      timeAvailable: "आज उपलब्ध समय (मिनट)",
      generate: "मेरी योजना बनाएं",
      generating: "बनाया जा रहा है",
      wrongTopics: "सुधार योग्य विषय",
      todayPlan: "आज की योजना",
      weeklyBlueprint: "साप्ताहिक योजना",
      recommendations: "सिफारिशें"
    },
    challenges: {
      newActivity: "नई गतिविधि",
      title: "चैलेंज मोड",
      subtitle: "वास्तविक परिदृश्य, AI मूल्यांकन और पुरस्कार।",
      create: "चैलेंज बनाएं",
      skill: "कौशल",
      duration: "अवधि",
      difficulty: "कठिनाई",
      generate: "चैलेंज बनाएं",
      yourSubmission: "आपकी प्रस्तुति (केवल टेक्स्ट)",
      submit: "AI मूल्यांकन हेतु भेजें",
      rewards: "पुरस्कार",
      recentAttempts: "हालिया प्रयास",
      aiEvaluation: "AI मूल्यांकन"
    }
  },

  sq: {
    common: {
      dashboard: "Paneli",
      profile: "Profili",
      logout: "Dil",
      hey: "Përshëndetje",
      language: "Gjuha",
      learningLanguage: "Gjuha e mësimit",
      selectLanguage: "Zgjidh gjuhën",
      saveSuccess: "U përditësua me sukses",
      upgradeRequired: "Kërkohet përmirësim",
      standardPremiumOnly: "Kjo veçori është e disponueshme vetëm për planet Standard dhe Premium.",
      viewPlans: "Shiko planet"
    },
    routes: {
      dashboard: "Paneli",
      exploreSkills: "Eksploro aftësitë",
      myLearning: "Mësimi im",
      myCoach: "Trajneri im",
      challenges: "Sfidat",
      skillAssessment: "Vlerësimi i aftësive",
      h2hQuiz: "Kuiz H2H",
      profile: "Profili"
    },
    coach: {
      title: "Plan mësimi ditor dhe javor i personalizuar",
      subtitle: "Bazuar në progresin, kuizet, vazhdimësinë dhe objektivin tënd.",
      planInputs: "Parametrat e planit",
      tuneInputs: "Rregullo dhe rigjenero planin.",
      goal: "Qëllimi",
      timeAvailable: "Koha e lirë sot (minuta)",
      generate: "Gjenero planin tim",
      generating: "Duke gjeneruar",
      wrongTopics: "Tema për përmirësim",
      todayPlan: "Plani i sotëm",
      weeklyBlueprint: "Plani javor",
      recommendations: "Rekomandime"
    },
    challenges: {
      newActivity: "Aktivitet i ri",
      title: "Modaliteti Sfidë",
      subtitle: "Skenarë realë, vlerësim nga AI dhe shpërblime.",
      create: "Krijo sfidë",
      skill: "Aftësia",
      duration: "Kohëzgjatja",
      difficulty: "Vështirësia",
      generate: "Gjenero sfidë",
      yourSubmission: "Dorëzimi yt (tekst për tani)",
      submit: "Dërgo për vlerësim AI",
      rewards: "Shpërblime",
      recentAttempts: "Përpjekje të fundit",
      aiEvaluation: "Vlerësimi AI"
    }
  }
};
